import React from 'react';
import { hapticFeedback } from '../utils/haptic';

interface FrequencyControlProps {
  frequency: number;
  isPlaying: boolean;
  onPlay: () => void;
  onStop: () => void;
  playText?: string;
}

export const FrequencyControl: React.FC<FrequencyControlProps> = ({
  frequency,
  isPlaying,
  onPlay,
  onStop,
  playText = 'Start Test',
}) => {
  return (
    <div className="flex justify-center gap-4">
      {!isPlaying ? (
        <button
          onClick={() => {
            hapticFeedback.audioStart();
            onPlay();
          }}
          className="medical-button px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 text-lg shadow-medical tap-highlight-none"
        >
          {playText}
        </button>
      ) : (
        <button
          onClick={() => {
            hapticFeedback.audioStop();
            onStop();
          }}
          className="medical-button px-8 py-4 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 text-lg shadow-medical tap-highlight-none"
        >
          Stop Sound
        </button>
      )}
    </div>
  );
};